<template>
    <el-dialog
        :title="po.menuForm.id > 0 ? '编辑分类' : '新增分类'"
        v-model="po.show"
        append-to-body
        :close-on-click-modal="false"
        width="40%"
        :before-close="close"
    >
        <el-form :model="po.menuForm" ref="poFormRef" label-width="120px" :rules="rules">
            <!-- <el-form-item prop="pid" label="父级菜单">
                <el-select v-model="po.menuForm.pid">
                    <el-option
                        :key="item.ename"
                        :label="item.cname"
                        :value="item.id"
                        v-for="item in props.parentMenus"
                    />
                </el-select>
            </el-form-item> -->
            <el-form-item prop="sort" label="排序">
                <el-input v-model="po.menuForm.sort" autocomplete="off"></el-input>
                <p>数值越大越靠前</p>
            </el-form-item>
            <el-form-item prop="cname" label="分类名称">
                <el-input v-model="po.menuForm.cname" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="ename" label="英文名">
                <el-input v-model="po.menuForm.ename" autocomplete="off"></el-input>
            </el-form-item> -->
            <!-- <el-form-item prop="path" label="菜单路径">
                <el-input v-model="po.menuForm.path" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="is_form" label="是否表单">
                <el-switch v-model="po.menuForm.is_form" :active-value="1" :inactive-value="0" />
            </el-form-item> -->
            <!-- <el-form-item props="imgUrl" label="默认图片">
                <el-upload
                    :action="requestDomain + '/api/attachments/uploadOtherFiles'"
                    :limit="1"
                    :on-success="handleSuccess"
                    class="attachment-uploader"
                    ref="uploadRef"
                    accept=".png,.jpg,.jpeg"
                >
                    <el-button text v-if="!po.menuForm.imgUrl">
                        <el-icon :size="32"><Plus /></el-icon>
                    </el-button>
                    <el-image
                        v-else
                        :src="requestDomain + po.menuForm.imgUrl"
                        alt=""
                        fit="contain"
                        style="width: 98px; height: 98px"
                    />
                    <template #tip>
                        <div class="el-upload__tip">点击可修改</div>
                    </template>
                </el-upload>
            </el-form-item> -->
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';
import { Plus } from '@element-plus/icons-vue';
import { requestDomain } from '../../../../package.json';
const props = defineProps({
    visible: Boolean,
    configInfo: Object,
    parentMenus: Array
});
const emit = defineEmits(['parentCallback', 'closeDialog']);
const uploadRef = ref();
const handleSuccess = e => {
    po.menuForm.imgUrl = e.url;
    uploadRef.value.clearFiles();
};

const poFormRef = ref();

const rules = reactive({
    cname: [{ required: true, trigger: 'change', message: '请输入分类名称' }]
    // ename: [{ required: true, trigger: 'change', message: '请输入英文名' }],
    // path: [{ required: true, trigger: 'change', message: '请输入菜单路径' }]
});
let po = reactive({
    show: props.visible,
    menuForm: props.configInfo
});

const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            const requestMethod = po.menuForm.id !== 0 ? 'updateConfig' : 'addConfig';
            const result = await request(requestMethod, po.menuForm);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
            emit('parentCallback');
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
const close = () => {
    emit('closeDialog');
};
const resetForm = poFormRef => {
    poFormRef.resetFields();
    close();
};
</script>
<style lang="scss">
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
.attachment-uploader .el-button {
    height: 100px;
    width: 100px;
    border: 1px dashed #cdd0d6;
}
</style>
